import { routes } from 'src/routes';

export type StudentTab = {
  label: string;
  id: string;
  to: string;
};

type StudentTabsInput = {
  goalsTitle: string;
  /** Paras bill without goals, so they get no Goals tab. */
  isPara: boolean;
  hasSeItService: boolean;
};

export const getStudentTabs = ({
  goalsTitle,
  isPara,
  hasSeItService,
}: StudentTabsInput): StudentTab[] => [
  { label: 'Schedule', id: 'schedule', to: routes.singleStudent.schedule },
  ...(isPara ? [] : [{ label: goalsTitle, id: 'goals', to: routes.singleStudent.goals }]),
  { label: 'About', id: 'about', to: routes.singleStudent.about },
  { label: 'Contacts', id: 'contact', to: routes.singleStudent.contact },
  { label: 'Notes', id: 'notes', to: routes.singleStudent.notes },
  ...(hasSeItService
    ? [
        { label: 'Activities', id: 'activities', to: routes.singleStudent.activities },
        { label: 'Documents', id: 'documents', to: routes.singleStudent.documents },
      ]
    : []),
];
